import { Button, VStack } from '@chakra-ui/react'
import React from 'react'
import { RiAddCircleFill, RiDashboardFill, RiEyeFill, RiUserFill } from 'react-icons/ri'
import { Link, useLocation } from 'react-router-dom'

const Slidebar = () => {
  const location=useLocation()
  return (
    <VStack spacing={'8'} p='16' boxShadow={'-2px 0 10px rgba(107,70,193,0.5)'}>
      <LinkButton Icon={RiDashboardFill} text="Dashboard" url={'dashboard'} active={location.pathname==="/admin/dashboard"}/>
      <LinkButton active={location.pathname==="/admin/createcourse"} Icon={RiAddCircleFill} text="Create Course" url={'createcourse'}/>
      <LinkButton active={location.pathname==="/admin/courses"} Icon={RiEyeFill} text="Courses" url={'courses'}/>
      <LinkButton active={location.pathname==="/admin/users"} Icon={RiUserFill} text="Users" url={'users'}/>
      
     
    </VStack>
  )
}

export default Slidebar
function LinkButton({url,Icon,text,active}){
  return(
    <Link to={`/admin/${url}`}><Button colorScheme={active ? "purple":""} fontSize={'larger'} variant={'ghost'}>
      <Icon style={{margin:'4px'}}/>
      {text}
        </Button></Link>
  )
}